export default "__VITE_ASSET__o4xti0Q6__"